// ['precios','lista',hq] invalida todas las listas de una empresa tras editar.
export const preciosKeys = {
  all: ['precios'],
  centros: (hq) => ['precios', 'centros', hq],
  listas: (hq) => ['precios', 'lista', hq],
  lista: (hq, filtros) => ['precios', 'lista', hq, filtros],
};

export default preciosKeys;
